import { createSelector } from "reselect";
import { LensAddOnVariantStepContainer } from "../../../../../../../../steps/LensAddOnVariantStep/steps/LensAddOnVariantStep/LensAddOnVariantStepContainer.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getSelectedAddOn } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
const lensAddOnVariantStep = {
  stepStatus: createSelector(
    getSelectedAddOn,
    (selectedAddOn) => Number(selectedAddOn?.variants?.length) > 1 ? "sub-step" : "hidden"
  ),
  view: LensAddOnVariantStepContainer
};
export {
  lensAddOnVariantStep
};
//# sourceMappingURL=lens-add-on-variant.js.map
